"use client";

import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
} from "@/components/ui/alert-dialog";
import StrategyTemplate from "@/components/walk-through/explore/StrategyTemplate";
import { motion } from "framer-motion";
import { useRouter } from "next/router";

import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppDetails } from "@/contexts/AppDetailsContext";

const Banner = () => {
  const router = useRouter();
  const { t } = useTranslation("common-page");
  const { details } = useAppDetails();
  // Only show banner on build pages
  if (!router?.pathname?.includes("build")) return null;
  const [ftuOpen, setFtuOpen] = useState<boolean>(false);

  const bannerMsg =
    details?.whiteLableOptions?.template_banner_message?.message ||
    "Explore ready-made strategies with zero setup or risk.";
  const bannerCta =
    details?.whiteLableOptions?.template_banner_message?.cta ||
    "Try them in paper trading mode now";

  return (
    <>
      <motion.div
        initial={{ height: 0, opacity: 0 }}
        animate={{ height: "2rem", opacity: 1 }}
        transition={{ duration: 0.3, ease: "linear" }}
        className="overflow-hidden bg-[#1E293B] sm:h-8 h-12 flex items-center sm:px-10 sm:text-base font-extrabold text-center text-xs px-8"
      >
        <p>
          <span className="text-[--accent-primary]">{t("NEW")}</span> -{" "}
          {t(bannerMsg)}{" "}
          <span
            onClick={() => setFtuOpen(true)}
            className="hover:text-[--accent-primary] underline underline-offset-2 cursor-pointer"
          >
            {t(bannerCta)}
          </span>
        </p>
      </motion.div>
      <AlertDialog open={ftuOpen} onOpenChange={(open) => setFtuOpen(open)}>
        <AlertDialogContent className="max-w-5xl px-3 ">
          <div className="w-full flex flex-col">
            <StrategyTemplate />
            <div className="w-full flex justify-end mt-2">
              <AlertDialogCancel>
                <>{t("Close")}</>
              </AlertDialogCancel>
            </div>
          </div>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};

export default Banner;
